import React from "react";
import { Briefcase, ChevronDown } from "lucide-react";

const JobSelectionDropDown = ({
  selectedJob,
  onJobChange,
  jobs,
  currentView,
}) => {

  return (
    currentView !== "create-job" &&
    jobs &&
    jobs.length > 0 && (
      <div className="relative mr-2 md:mr-4">
        <Briefcase
          className="absolute left-3 top-1/2 mt-2 transform -translate-y-1/2 text-gray-400"
          size={18}
        />
        <select
          value={selectedJob}
          onChange={onJobChange}
          className="pl-10 pr-12 py-3 border-2 border-blue-500 rounded-md text-gray-700 bg-white shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 appearance-none cursor-pointer text-sm md:text-base w-full min-h-[44px]"
        >
          <option value="">Select a job...</option>
          {jobs.map((job) => (
            <option key={job._id} value={job._id}>
              {job.jobReference}
            </option>
          ))}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center justify-center w-12 text-gray-700">
          <ChevronDown size={18} />
        </div>
      </div>
    )
  );
};

export default JobSelectionDropDown;
